import {
  LOAD_PREFERENCIAS,
  UPDATE_PREFERENCIAS,
  RESET_PREFERENCIAS
} from './preferencias-constants';

export const loadPreferencias = () => ({
  type: LOAD_PREFERENCIAS,
});

export const updatePreferencias = (key, value) => ({
  type: UPDATE_PREFERENCIAS,
  payload: { key, value },
});

export const resetPreferencias = () => ({
  type: RESET_PREFERENCIAS,
});
